<template>
	<section
		class="modal"
		:class="{
			'modal--light': light,
			'modal--narrow': narrow,
			'modal--full-height': fullHeight,
			'modal--full-screen': fullScreen,
		}"
		:id="id"
		v-if="visible"
		v-htmlclass="customHtmlClasses"
	>
		<div
			class="modal__backdrop"
			v-if="!fullScreen"
		/>
		<div
			ref="wrapper"
			class="modal__wrapper"
			:class="{
				'modal__wrapper--full-screen': fullScreen,
			}"
			@click="closeFromWrapper"
		>
			<div
				class="modal__window"
				:class="{
					'modal__window--light': light,
					'modal__window--narrow': narrow,
					'modal__window--full-height': fullHeight,
					'modal__window--full-screen': fullScreen,
					'modal__window--no-padding': noPadding,
				}"
			>
				<button
					class="modal__close"
					@click.prevent="close(softClose)"
					v-if="!noClose"
				>
					<SVGClose/>
				</button>
				<div class="modal__content">
					<slot :closeModal="() => close(softClose)"/>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import htmlComponent from 'htmlcomponent'
import {storeScrollPos, restoreScrollPos} from '@/utils/scrollpos';
import GenericMixin from '@/mixins/GenericVueMixin';
import OverlayMixin from '@/mixins/OverlayVueMixin';

export default {
	mixins: [
		GenericMixin,
		OverlayMixin,
	],
	props: {
		id: String,
		initialVisible: {
			type: Boolean,
			default: false
		},
		overlayType: {
			type: String,
			default: 'modal'
		},
		light: Boolean,
		narrow: Boolean,
		fullHeight: Boolean,
		fullScreen: Boolean,
		noPadding: Boolean,
		noClose: Boolean,
		softClose: Boolean,
	},
	data() {
		return {
			visible: this.initialVisible
		};
	},
	watch: {
		initialVisible(newValue) {
			this.visible = newValue;
		},
	},
	methods: {
		open() {
			this.visible = true;
			this.openOverlay();
			this.$emit('open');
		},
		close(softClose) {
			if (softClose) {
				this.$emit('softclose');
			}
			else {
				this.visible = false;
				this.closeOverlay();
				this.$emit('close');
			}
		},
		closeFromWrapper(e) {
			if (e.target == this.$refs.wrapper) {
				this.close(this.softClose);
			}
		},
		openOverlayHandler(e, data)  {
			if (data.type !== this.overlayType) {
				this.html.classList.remove(this.overlayShowClass);
				this.visible = false;
			}
			else {
				if (!this.overlayIgnoreScrollPos) {
					storeScrollPos();
				}
				this.$emit('open');
				this.$emit('data', data);
				this.html.classList.add(this.overlayShowClass);
				this.visible = true;
			}
		},
		closeOverlayHandler(e, data) {
			if (data.type === this.overlayType) {
				this.$emit('close');
				this.$emit('data', data);
				this.html.classList.remove(this.overlayShowClass);
				this.visible = false;

				if (!this.overlayIgnoreScrollPos) {
					restoreScrollPos();
				}
			}
		},
		toggleOverlayHandler(e, data) {
			if (data.type === this.overlayType) {
				if (this.html.classList.contains(this.overlayShowClass)) {
					htmlComponent.send('overlay:close', data);
				}
				else {
					htmlComponent.send('overlay:open', data);
				}
			}
		},
		scrollTop(value = 0) {
			this.$refs.wrapper.scrollTop = value;
		}
	}
}
</script>

<style>

</style>
